import React, {PropTypes} from 'react';
import classNames from 'classnames';

const A = ({children, href, className, onClick}) => {
  const cssClass = classNames({
    link: true,
    'link--colored': true,
  }, className);

  return (
    <a href={href} className={cssClass} onClick={onClick}>
      {children}
    </a>
  );
};

A.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node,
  ]),
  className: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

export default A;
